import { render } from "./Menubar.vue?vue&type=template&id=a89d8040"
import script from "./Menubar.vue?vue&type=script&lang=js"
export * from "./Menubar.vue?vue&type=script&lang=js"

import "./Menubar.vue?vue&type=style&index=0&id=a89d8040&lang=css"
script.render = render

export default script